import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';
class BuPlanWithDrawAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'buPlanWithDraws';
  /**
   * Xóa rút dự toán
   * NXCHIEN 15.04.2022
   */
  deleteMultiBUPlan(param) {
    let request = {
      url: this.getAPIUrl() + '/MultiDeleteBUPlan',
      data: param,
    };

    return httpClient.deleteAsync(request, true);
  }

  /**
   * Lấy dữ liệu cho lập nhanh giấy rút từ bảng kê
   * @returns
   * DTQUOC 06.10.2023
   */
  getVoucherListCash(payload) {
    let request = {
      url: this.getAPIUrl() + '/VoucherList',
      data: payload
    };
    return httpClient.postAsync(request);
  }
  /**
   * Sinh dữ liệu Rút dụ toán chuyển khoản từ chuyển khoản kho bạc
   * NXCHIEN 17.07.2022
   */
  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT
   * @param {*} refId
   * @returns
   */
  getDataForEnterPaymentContent(refId) {
    let request = { url: [this.getAPIUrl(), `GetDataForEnterPaymentContent?refId=${refId}`].join('/') };
    return httpClient.getAsync(request);
  }

  deleteRefRelationId(payload) {
    let request = {
      url: this.getAPIUrl() + '/DeleteRelationId',
      data: payload,
    };
    return httpClient.deleteAsync(request);
  }
}

export default new BuPlanWithDrawAPI();
